import React from "react";
import { Box, Card } from "@mui/material";
import FaiBox from "MuiComponents/FaiBox";
import FaiTypography from "MuiComponents/FaiTypography";
import StatisticsCard from "screens/Customer/components/StatisticCard";
import AddCategory from "screens/Category/components/AddCategory";
import Tickets from "screens/Tickets";

const Dashboard: React.FC = (props) => {
	return (
		<>
			<Card className="bg-white rounded-2xl my-6 p-3 md:p-4">
				<FaiBox className={"inventory"}>
					<FaiTypography
						variant={"h4"}
						className="!text-xl !font-semibold"
						mb={2}
					>
						Pending
					</FaiTypography>
				</FaiBox>
				<Box className="grid grid-cols-2 md:grid-cols-4 gap-3">
					<StatisticsCard
						title="New Customer Onboarding"
						number="231"
						change={"3.56"}
					/>
					<StatisticsCard title="Total Review" number="231" change={"3.56"} />
					<StatisticsCard title="Order Place" number="231" change={"3.56"} />
					<StatisticsCard title="Order Returns" number="231" change={"3.56"} />
				</Box>
			</Card>
			<Card className="bg-white rounded-2xl my-6 p-3 md:p-4">
				<FaiBox className={"inventory"}>
					<FaiTypography
						variant={"h4"}
						className="!text-xl !font-semibold"
						mb={2}
					>
						Payment
					</FaiTypography>
				</FaiBox>
				<Box className="grid grid-cols-2 md:grid-cols-3 gap-3">
					<StatisticsCard title="Total Revenue" number="231" change={"3.56"} />
					<StatisticsCard
						title="Merchant payouts"
						number="231"
						change={"3.56"}
					/>
					<StatisticsCard
						title="Profit after payouts"
						number="231"
						change={"3.56"}
					/>
				</Box>
			</Card>
			<AddCategory />
			<Tickets type="ongoing" />
		</>
	);
};

export default Dashboard;
